/**
 * noteOptionsSx.js
 * Shared MUI sx constants for NoteOptionsPanel components.
 * Single source of truth for all Jerny dark theme styling in this panel.
 */

/** Panel container */
export const panelSx = {
    position: 'fixed',
    zIndex: 9999,
    background: '#0d1f33',
    border: '0.5px solid #294766',
    borderRadius: '4px',
    fontFamily: "'DM Sans', sans-serif",
    color: '#b0c8e0',
    minWidth: 220,
    boxShadow: '0 8px 28px rgba(0,0,0,0.6)',
    userSelect: 'none',
};

/** Titlebar — drag handle */
export const titlebarSx = {
    display: 'flex',
    alignItems: 'center',
    background: '#05407a',
    borderBottom: '0.5px solid #294766',
    borderRadius: '4px 4px 0 0',
    color: '#a3d1ff',
    fontSize: '13px',
    fontWeight: 600,
    padding: '5px 8px',
    cursor: 'grab',
    userSelect: 'none',
};

/** Action row */
export const menuItemSx = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '5px 12px',
    cursor: 'pointer',
    fontSize: '12px',
    color: '#b0c8e0',
    fontFamily: "'DM Sans', sans-serif",
    '&:hover': { background: '#05407a' },
};

/** Delete row */
export const deleteItemSx = {
    ...menuItemSx,
    color: '#ff6b6b',
    '&:hover': { background: 'rgba(255,107,107,0.1)' },
};

/** Row icon — 13px matches 12px label font */
export const iconSx = { fontSize: '13px', color: '#7fb3d3', flexShrink: 0 };

/** Delete row icon */
export const deleteIconSx = { ...iconSx, color: '#ff6b6b' };

/** Section label above toggles */
export const sectionLabelSx = {
    fontSize: 10,
    color: '#4a6a80',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    padding: '4px 12px 2px',
};

/** Horizontal separator */
export const separatorSx = { borderBottom: '0.5px solid #294766', margin: '4px 0' };

/** Jerny-styled toggle button for dark backgrounds */
export const toggleBtnSx = {
    fontSize: 10,
    py: '2px',
    px: '6px',
    color: '#7fb3d3',
    borderColor: '#294766',
    bgcolor: 'transparent',
    '&.Mui-selected': { bgcolor: '#05407a', color: '#a3d1ff', borderColor: '#294766' },
    '&.Mui-selected:hover': { bgcolor: '#05407a' },
    '&:hover': { bgcolor: '#0a2a40' },
};
